// Entry point for the build script in package.json
import "@hotwired/turbo-rails"
import "./controllers"
import "./channels"

import "trix"
import "@rails/actiontext"

// Swiper initialization for header
import { Swiper } from 'swiper'
import { Autoplay } from 'swiper/modules'

// Flowbite initialization
import { initFlowbite } from 'flowbite'

// Global header swiper instance
let headerSwiper = null

// Function to initialize header Swiper
function initHeaderSwiper() {
  const headerElement = document.getElementById('header-carousel')
  
  if (headerElement && !headerSwiper) {
    headerSwiper = new Swiper('#header-carousel', {
      modules: [Autoplay],
      slidesPerView: 1,
      passiveListeners: true,
      loop: true,
      speed: 600,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      }
    })
  }
}

// Duotalk chat controls (widget loads once from the head <script> tag and is
// preserved across Turbo navigations; no re-initialization here).
// O widget do Duotalk roda num iframe cross-origin e NÃO expõe API de abrir por
// mensagem em runtime — o estado "aberto" só é lido do parâmetro de URL
// `isChatOpen=true` quando o iframe carrega (confirmado no bundle do widget).
// Então para abrir por código a gente recarrega o iframe com esse parâmetro: ele
// sobe já aberto, avisa o parent (postMessage 'chatOpen') e o snippet expande o
// container (resizeChat).

// Entrada única para os botões "falar pelo chat" das páginas. Com o nosso
// launcher ativo, quem revela o chat é ele (openChat direto abriria o widget
// ESCONDIDO atrás da barra); sem launcher, abre o widget nativamente.
window.requestChat = function () {
  if (document.body.classList.contains("chat-launcher-active")) {
    window.dispatchEvent(new CustomEvent("chat:open"))
  } else {
    window.openChat()
  }
}

window.openChat = function () {
  const frame = document.getElementById('duotalk-chat-widget-frame')
  if (!frame) return
  // NÃO setamos widget.dataset.open aqui: deixamos o próprio iframe sinalizar
  // 'chatOpen' quando terminar de recarregar e abrir de fato. Assim quem está
  // cobrindo (nosso launcher) só troca pelo chat no momento certo, sem piscar o
  // balão original durante o reload.
  try {
    const url = new URL(frame.src)
    url.searchParams.set('isChatOpen', 'true')
    url.searchParams.set('_dt', Date.now().toString()) // garante reload mesmo se a URL não mudou
    frame.src = url.toString()
  } catch (_) {}
}

window.closeChat = function () {
  const widget = document.getElementById('duotalk-chat-widget')
  if (widget) widget.dataset.open = 'false'
}

// Function to safely initialize Flowbite
function safeInitFlowbite() {
  try {
    initFlowbite()
  } catch (error) {
    console.warn('Flowbite initialization failed:', error)
  }
}

// Initialize everything on page load
document.addEventListener('DOMContentLoaded', () => {
  initHeaderSwiper()
  safeInitFlowbite()
})

// Re-initialize Flowbite after Turbo navigation (but NOT header swiper)
document.addEventListener('turbo:load', () => {
  safeInitFlowbite()
})

// Re-initialize Flowbite after Turbo frame load
document.addEventListener('turbo:frame-load', () => {
  safeInitFlowbite()
})

// Also initialize after stimulus controllers are loaded
document.addEventListener('stimulus:connect', () => {
  setTimeout(() => safeInitFlowbite(), 100)
})
